
import React from 'react';
import { Box, Typography } from '@mui/material';
import NavGroup from './NavGroup';
import useMenuItems from 'menu-items';

const Navigation = () => {
  const { items } = useMenuItems();

  if (!items || !Array.isArray(items)) {
    return <Typography variant="h6" color="error" align="center">No menu items available</Typography>;
  }

  const navGroups = items?.map((item) => {

    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            No Nav Items Exist !
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
